import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { School as SchoolIcon, ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Classes() {
    const [classes, setClasses] = useState([]);
    const [active, setActive] = useState(null);
    const [students, setStudents] = useState([]);

    useEffect(() => { api.get("/classes").then(r => setClasses(r.data)); }, []);

    const openClass = async (c) => {
        setActive(c);
        const { data } = await api.get(`/classes/${c.id}/students`);
        setStudents(data);
    };

    if (active) {
        return (
            <div className="space-y-4">
                <Button variant="ghost" onClick={() => { setActive(null); setStudents([]); }} data-testid="btn-back-classes"><ChevronLeft className="w-4 h-4 ml-1" /> رجوع للفصول</Button>
                <div>
                    <h1 className="text-2xl font-bold text-[#0F172A]">{active.name}</h1>
                    <p className="text-sm text-slate-500 mt-1">{students.length} طالبة</p>
                </div>
                <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50 text-xs uppercase text-slate-600"><tr><th className="px-4 py-3 text-right">#</th><th className="px-4 py-3 text-right">الاسم</th><th className="px-4 py-3 text-right">رقم الهوية</th></tr></thead>
                        <tbody>{students.map((s, i) => <tr key={s.id} className="border-t border-slate-100"><td className="px-4 py-3 font-mono-num">{i + 1}</td><td className="px-4 py-3 font-medium">{s.full_name}</td><td className="px-4 py-3 font-mono-num" dir="ltr">{s.national_id}</td></tr>)}</tbody>
                    </table>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-5">
            <div>
                <h1 className="text-2xl font-bold text-[#0F172A]">الفصول</h1>
                <p className="text-sm text-slate-500 mt-1">توزيع الطالبات على الفصول</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {classes.length === 0 && <div className="col-span-full text-center py-12 text-slate-400">لا توجد فصول بعد — استوردي ملف Excel لإنشائها تلقائياً</div>}
                {classes.map((c) => (
                    <button key={c.id} onClick={() => openClass(c)} data-testid={`class-card-${c.id}`} className="text-right bg-white border border-slate-200 rounded-xl p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
                        <div className="w-10 h-10 rounded-lg bg-[#FFF1F2] text-[#C8102E] flex items-center justify-center mb-3"><SchoolIcon className="w-5 h-5" /></div>
                        <div className="font-semibold text-[#0F172A]">{c.name}</div>
                        <div className="text-xs text-slate-500 mt-1 font-mono-num">{c.student_count} طالبة</div>
                    </button>
                ))}
            </div>
        </div>
    );
}
